import "./case-study-block.scss";
import { Block } from "modules/Block";

export class CaseStudyBlock extends Block<typeof CaseStudyBlock> {
    static readonly className: string = "js-case-study-block";

    private allAccordions?: NodeListOf<HTMLElement> | null;

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.allAccordions = rootElement.querySelectorAll<HTMLElement>(".js-accordion-expand");

        this.allAccordions.forEach((accordion) => {
            accordion.addEventListener("click", this.handleAccordionClick);
        });
    }

    private handleAccordionClick = (e: MouseEvent) => {
        const clickedAccordion = e.currentTarget;

        if (!(clickedAccordion instanceof Element)) return;

        const isActive = clickedAccordion?.classList.contains("active");

        if (isActive) {
            return;
        }

        this.allAccordions?.forEach((accordion) => {
            accordion.classList.remove("active");
            accordion.closest(".qna__item")?.classList.remove("active");
            accordion.nextElementSibling?.setAttribute("aria-expanded", "false");
        });

        if (!isActive) {
            clickedAccordion.classList.add("active");
            clickedAccordion.closest(".qna__item")?.classList.add("active");
            clickedAccordion.nextElementSibling?.setAttribute("aria-expanded", "true");
        }
    }
}